module.exports = __webpack_public_path__ + "static/media/arrowLeft.662afec9.svg";